export default [
  'INIT',
  'LEAVE',
  'REFETCH',
  'FETCH_POLLS_SUCCESS',
  ['DELETE_POLL', 'pollId'],
  ['TOGGLE_EDIT_POLL', 'pollId'],
  ['ACTIVATE_POLL', 'poll'],
  ['ANSWER_POLL', 'poll', 'optionId', 'uuid'],
  ['SET_ANSWERED_POLL_ID', 'pollId'],
  'TOGGLE_CREATE_POLL_FORM_VISIBILITY',
  ['ON_CREATE_EDIT_SUBMIT', 'values', 'submitPromise', 'pollId'],
]
